import { MessageCircle, Ticket } from "lucide-react";

export default function FloatingWhatsApp() {
  return (
    <a
      href="#elegir-ficha"
      className="fixed bottom-6 right-6 z-40 group"
      data-testid="floating-whatsapp"
      aria-label="Elegir ficha para participar"
    >
      <span className="absolute inset-0 rounded-full pulse-ring" />
      <span className="relative flex items-center gap-3 bg-[#25D366] hover:bg-[#20BC5A] text-white px-5 py-4 rounded-full shadow-[0_15px_40px_-10px_rgba(37,211,102,0.7)] transition-all hover:-translate-y-1 hover:scale-105">
        <Ticket className="w-6 h-6" strokeWidth={2.5} />
        <span className="hidden md:inline font-bebas text-lg tracking-wider">
          Adquirir Ficha
        </span>
      </span>
    </a>
  );
}
